<template>	
  <section class="profile-info">	
    <af-h4 class="profile-info-header">	
      <icon class="profile-info__icon" fill="rgb(6, 118, 159)" type="info-circle"></icon>	
      <slot name="title"></slot>	
    </af-h4>	
	
    <slot name="content"></slot>	
	
    <router-link class="profile-info__link" target="_blank" to="/arbetsgivarinformation">	
      <icon link type="angle-right"></icon>	
      <span class="profile-info__link-text">	
        <slot name="link"></slot>	
      </span>	
    </router-link>	
  </section>	
</template>	
	
<script>	
import Icon from '@/components/Icon'	
import AfH4 from '@/components/AfH4'	
	
export default {	
  name: 'ProfileInfo',	
  components: {	
    Icon,	
    AfH4	
  },	
  props: {	
    onLinkClick: Function	
  }	
}	
</script>	
	
<style lang="postcss" scoped>	
.profile-info {	
  -ms-grid-column: 2;	
  -ms-grid-row: 1;	
	
  background-color: var(--color-link-water);	
  border: solid 1px var(--color-mint-tulip);	
  border-radius: 4px;	
  padding: 30px;	
}	
	
.profile-info-header {	
  display: flex;	
}	
	
.profile-info--no-at-und {	
  background-color: var(--color-pearl-lusta);	
}	
	
.profile-info__icon {	
  margin-right: var(--spacing-third);	
}	
	
.profile-info__link {	
  align-items: flex-start;	
  display: flex;	
  & .fa-angle-right {	
    margin-top: 5px;	
  }	
	
  & > span {	
    margin-left: 6px;	
  }	
}	
</style>



// WEBPACK FOOTER //
// src/views/Profile/ProfileInfo.vue